<script lang="ts">
    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import { _ } from 'svelte-i18n';
    import SettingsRow from './SettingsRow.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import Select from '../../shared/Select.svelte';
    import { customerSettings } from '../../../stores/api';

    export let update: () => void;

    const sortOptions = [
        { id: 'original', label: $_('Jak w oryginalnym pliku') },
        { id: 'by_zone', label: $_('by_delivery_order') },
    ];

    let selectedValue = $customerSettings.export.realisation_sort_by_zone;

    function handleChange(newValue: string) {
        $customerSettings.export.realisation_sort_by_zone = newValue as 'original' | 'by_zone';
        update();
        return true;
    }
</script>

<TemplateSettingsGeneral>
    <div slot="label">{$_('export_settings')}</div>
    <div slot="content">
        <SettingsRow>
            <SettingsRowLabel>
                {$_('Sortowanie eksportu realizacji')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <Select
                    items={sortOptions}
                    bind:selected={selectedValue}
                    onChange={handleChange}
                />
            </SettingsRowValue>
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>

